var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 2.88329C11.3532 2.88329 12.4498 3.97996 12.4498 5.33329C12.4498 6.68663 11.3532 7.78329 9.99984 7.78329C8.6465 7.78329 7.54984 6.68663 7.54984 5.33329C7.54984 3.97996 8.6465 2.88329 9.99984 2.88329ZM9.99984 13.3833C13.4648 13.3833 17.1165 15.0866 17.1165 15.8333V17.1166H2.88317V15.8333C2.88317 15.0866 6.53484 13.3833 9.99984 13.3833ZM9.99984 0.666626C7.4215 0.666626 5.33317 2.75496 5.33317 5.33329C5.33317 7.91163 7.4215 9.99996 9.99984 9.99996C12.5782 9.99996 14.6665 7.91163 14.6665 5.33329C14.6665 2.75496 12.5782 0.666626 9.99984 0.666626ZM9.99984 11.1666C6.88484 11.1666 0.666504 12.73 0.666504 15.8333V19.3333H19.3332V15.8333C19.3332 12.73 13.1148 11.1666 9.99984 11.1666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.9b1ef4d09f382c70531c2fd56b529e62.svg";
export { ForwardRef as ReactComponent };